<template>
  <BaseDialog
    v-model="isActive"
    width="302"
    borderless-title
    hide-close-btn
  >
    <ResultsPlaceholder
      class="pt-16 pa-md-6"
      img-src="/graphics/success.svg"
      title="Заявка отправлена"
    >
      <template #subtitle>
        Специалист позвонит вам в течение одного рабочего дня.
      </template>
    </ResultsPlaceholder>
    <div class="mb-4 mx-2 d-md-flex justify-md-end mr-md-6">
      <BaseMtButton
        color="primary"
        variant="text"
        :block="$display.smAndDown.value"
        @click="hide"
      >
        Понятно
      </BaseMtButton>
    </div>
  </BaseDialog>
</template>

<script setup lang="ts">
import { useDisplay } from 'vuetify'

const isActive = ref(false)

const $display = useDisplay()

function open() {
  isActive.value = true
}

function hide() {
  isActive.value = false
}

defineExpose({
  open,
  hide,
})
</script>
